module.exports = __webpack_public_path__ + "img/main_bg_deco_2.327766c.webp";